<template>
  <div>
    <label
      v-if="label"
      class="form-label text-sm"
      :for="id">{{ label }}:</label>
    <vue-numeric
      :id="id"
      ref="input"
      v-model="num"
      currency=""
      separator="."
      class="form-input"
      :class="[{ error: error }, inputClass]"
      :disabled="disabled"
      @input="$emit('input', num)" />
    <div v-if="error" class="form-error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import VueNumeric from 'vue-numeric'

export default {
  components: {
    VueNumeric,
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default () {
        return `text-input-${this._uid}`
      },
    },
    value: {
      type: Number,
      default: 0,
    },
    label: String,
    error: String,
    inputClass: String,
    disabled: Boolean,
  },
  data () {
    return {
      num: this.value,
    }
  },
  methods: {
    focus () {
      this.$refs.input.focus()
    },
    select () {
      this.$refs.input.select()
    },
    setSelectionRange (start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>
